module.exports = __webpack_public_path__ + "img/close.1bb9650c.png";